// | ------------------------------------------------------------------------
// | Contact
// | ------------------------------------------------------------------------ 

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import validate from 'jquery-validation'

 


// | ------------------------------------------------------------------------